import cookie from 'js-cookie';
import { marvinjsUtil } from '../../components/chemical-highlight/utils/marvin';
import { CORE_SEARCH_SERVICE_URI } from 'library-@/config/apiConfig';

const MARVIN_SETTING = {
    imageType: 'image/svg',
    settings: {
        width: 150,
        height: 150,
        carbonLabelVisible: false,
        cpkColoring: true,
        // zoomMode: 'autoshrink',
        implicitHydrogen: 'HETERO',
        lonePairsVisible: false,
        lonepaircalculationenabled: false,
        displayMode: 'WIREFRAME',
        atomMapsVisible: true
    },
    // inputFormat: 'smiles',
    services: {
        molconvertws: `${CORE_SEARCH_SERVICE_URI}/core-search-api/search/patent/view/webservices/rest-v0/util/calculate/molExport`
    }
};

const state = {
    enable: cookie.get('pvChemicalHl') !== 'false',
    filters: ['t', 'a', 'c', 'd', 'k', 'o'],
    total: 0,
    isSelectAll: false,
    selectedStruct: [],
    deSelectedStruct: [],
    currentHighlight: '',
    structList: [],
    chemHighlightOthers: true,
    marvinInstance: null,
    // 存储结构式提取的各类型的对应的数量，字段名是各类型对应的key
    extractFormatCount: {}
};

const mutations = {
    setMarvinInstance(state, payload) {
        state.marvinInstance = payload;
    },
    updateChemHighlightOthers(state, payload) {
        state.chemHighlightOthers = payload;
    },
    updateEnable(state, isEnable) {
        state.enable = isEnable;
    },
    updateFilters(state, filters) {
        state.filters = filters;
    },
    updateTotal(state, total) {
        state.total = total;
    },
    updateSelectAll(state, isSelectAll) {
        state.isSelectAll = isSelectAll;
        state.selectedStruct = [];
        state.deSelectedStruct = [];
    },
    updateSelected(state, newSelect) {
        state.selectedStruct = newSelect;
    },
    updateCurrentHighlight(state, newHighlight) {
        state.currentHighlight = newHighlight;
    },
    updateStructList(state, structList) {
        state.structList = structList;
    },
    addSelected(state, structId) {
        state.selectedStruct.push(structId);
    },
    removeSelected(state, structId) {
        const idx = state.selectedStruct.indexOf(structId);

        if (idx > -1) {
            state.selectedStruct.splice(idx, 1);
        }
    },
    addDeselected(state, structId) {
        state.deSelectedStruct.push(structId);
    },
    removeDeselected(state, structId) {
        const idx = state.deSelectedStruct.indexOf(structId);

        if (idx > -1) {
            state.deSelectedStruct.splice(idx, 1);
        }
    },
    setStructList(state, structList) {
        state.structList = structList;
        state.selectedStruct = [];
        state.deSelectedStruct = [];
    },
    appendStructList(state, list) {
        state.structList = state.structList.concat(list);
    },
    setExtractFormatCount(state, countObject) {
        state.extractFormatCount = countObject;
    }
};

const actions = {
    async getMarvinExporter({ state, commit }, settings) {
        let marvin = state.marvinInstance;
        if (!state.marvinInstance) {
            marvin = await marvinjsUtil.getPackage('#marvinjs-package');
            await new Promise(resolve => {
                marvin.onReady(() => {
                    commit('setMarvinInstance', marvin);
                    resolve(marvin);
                });
            });
        }
        // 设置请求头
        marvin.Sketch.addRequestInterceptor(config => {
            config.setRequestHeader('X-API-Version', '2.0');
        });
        const exporter = new marvin.ImageExporter(Object.assign({}, MARVIN_SETTING, { settings: {
            ...MARVIN_SETTING.settings,
            ...settings
        } }));
        const cache = new Map();
        return {
            ...exporter,
            async render(smiles) {
                const cachedResult = cache.get(smiles);
                if (cachedResult) {
                    return cachedResult;
                }
                const result = await exporter.render(smiles);
                cache.set(smiles, result);
                return result;
            }
        };
    },
    updateEnable({ commit }, isEnable) {
        commit('updateEnable', isEnable);
        cookie.set('pvChemicalHl', isEnable);
    },
    updateFilters({ commit }, filters) {
        commit('updateFilters', filters);
    },
    updateTotal({ commit }, total) {
        commit('updateTotal', total);
    },
    updateSelectAll({ commit }, isSelectAll) {
        commit('updateSelectAll', isSelectAll);
    },
    //TODO: 没有用到
    updateSelected({ commit }, structId) {
        commit('updateSelected', structId);
    },
    updateCurrentHighlight({ commit }, structList) {
        commit('updateCurrentHighlight', structList);
    },
    //TODO: 没有用到
    updateStructList({ commit }, structList) {
        commit('updateStructList', structList);
    },
    addSelected({ commit }, structId) {
        commit('addSelected', structId);
    },
    removeSelected({ commit }, structId) {
        commit('removeSelected', structId);
    },
    addDeselected({ commit }, structId) {
        commit('addDeselected', structId);
    },
    removeDeselected({ commit }, structId) {
        commit('removeDeselected', structId);
    },
    setStructList({ commit }, structList) {
        commit('setStructList', structList);
    },
    appendStructList({ commit }, list) {
        commit('appendStructList', list);
    },
    updateChemHighlightOthers({ commit }, payload) {
        commit('updateChemHighlightOthers', payload);
    },
    setExtractFormatCount({ commit }, countObject) {
        commit('setExtractFormatCount', countObject);
    }
};

const getters = {
    enable: ({ enable }) => enable,
    filters: ({ filters }) => filters,
    total: ({ total }) => total,
    structList: ({ structList }) => structList,
    selectedStruct: ({ selectedStruct }) => selectedStruct,
    deSelectedStruct: ({ deSelectedStruct }) => deSelectedStruct,
    isSelectAll: ({ isSelectAll }) => isSelectAll,
    currentHighlight: ({ currentHighlight }) => currentHighlight,
    chemHighlightOthers: ({ chemHighlightOthers }) => chemHighlightOthers,
    chemicalHighlightEnable: ({ enable }) => enable,
    extractFormatCount: ({ extractFormatCount }) => extractFormatCount
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
